/* import __COLOCATED_TEMPLATE__ from './sales-tax-card.hbs'; */
import Component from '@glimmer/component';
export default class SalesTaxCard extends Component {}